
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/co-so-y-te",
      function () {
        return require("private-next-pages/co-so-y-te/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/co-so-y-te"])
      });
    }
  